
import {
  defineComponent, computed, reactive, watch, toRefs,
} from 'vue';
import { Card } from 'ant-design-vue';
import SelecionarCamposRelatorioVendas from './SelecionarCamposRelatorioVendas.vue';
import SelecionarTipoRelatorioPainelVendas from './SelecionarTipoRelatorioPainelVendas.vue';
import SelecionarTipoOperacao from '@/components/Cadastros/SelecionarTipoOperacao.vue';
import SelecionarColaborador from '@/components/Cadastros/Pessoas/Colaboradores/SelecionarColaborador.vue';
import SelecionarCliente from '@/components/Cadastros/Pessoas/Clientes/SelecionarCliente.vue';
import SelecionarProduto from '@/components/Cadastros/Produtos/SelecionarProduto.vue';
import { IDadosRelatorio } from '@/models/Entidades/Relatorios/DadosRelatorio';

export default defineComponent({
  name: 'CriacaoEdicaoLayoutModal',

  components: {
    Card,
    SelecionarCamposRelatorioVendas,
    SelecionarTipoRelatorioPainelVendas,
    SelecionarTipoOperacao,
    SelecionarColaborador,
    SelecionarCliente,
    SelecionarProduto,
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    modoEdicao: {
      type: Boolean,
      required: true,
    },
    codigoEmpresa: {
      type: Number,
      required: true,
    },
    empresasDisponiveis: {
      type: Array,
      required: true,
    },
    dadosCadastroInit: {
      type: Object as () => IDadosRelatorio,
      required: true,
    },
    dadosRelatorioCamposInit: {
      type: String,
      required: true,
    },
    tipoOperacaoModalInit: {
      type: Array as () => number[],
      required: true,
    },
    vendedoresModalInit: {
      type: Array as () => number[],
      required: true,
    },
    clientesModalInit: {
      type: Array as () => number[],
      required: true,
    },
    produtosModalInit: {
      type: Array as () => number[],
      required: true,
    },
  },

  emits: ['update:visible', 'salvar'],

  setup(props, { emit }) {
    const state = reactive({
      dadosCadastro: {} as IDadosRelatorio,
      dadosRelatorioCampos: '',
      tipoOperacaoModal: [] as number[],
      vendedoresModal: [] as number[],
      clientesModal: [] as number[],
      produtosModal: [] as number[],
    });

    const modalVisivel = computed({
      get: () => props.visible,
      set: (valor) => {
        emit('update:visible', valor);
      },
    });

    // Observa a visibilidade do modal para carregar os dados
    watch(() => props.visible, (isVisible) => {
      if (isVisible) {
        // Quando o modal abre, copia os dados das props para o estado local
        state.dadosCadastro = { ...props.dadosCadastroInit };
        state.dadosRelatorioCampos = props.dadosRelatorioCamposInit;
        state.tipoOperacaoModal = [...props.tipoOperacaoModalInit];
        state.vendedoresModal = [...props.vendedoresModalInit];
        state.clientesModal = [...props.clientesModalInit];
        state.produtosModal = [...props.produtosModalInit];

        if (props.modoEdicao && state.dadosCadastro.filtros && Array.isArray(state.dadosCadastro.filtros)) {
          const tiposDeFiltroSalvos: number[] = [];
          state.dadosCadastro.filtros.forEach((filtro) => {
            switch (filtro.tipoFiltro) {
              case 'TipoOperacao':
                if (!tiposDeFiltroSalvos.includes(1)) tiposDeFiltroSalvos.push(1);
                break;
              case 'Vendedor':
                if (!tiposDeFiltroSalvos.includes(2)) tiposDeFiltroSalvos.push(2);
                break;
              case 'Cliente':
                if (!tiposDeFiltroSalvos.includes(3)) tiposDeFiltroSalvos.push(3);
                break;
              case 'Produto':
                if (!tiposDeFiltroSalvos.includes(4)) tiposDeFiltroSalvos.push(4);
                break;
              default:
                break;
            }
          });
          state.dadosCadastro.tiposFiltro = tiposDeFiltroSalvos;
        }
      }
    }, { immediate: true });

    // Watcher para limpar valores quando deseleciona filtros
    watch(
      () => state.dadosCadastro.tiposFiltro,
      (novosTipos) => {
        if (!novosTipos || !Array.isArray(novosTipos)) {
          return;
        }

        // Se TipoOperacao foi deseleccionado, limpar valores
        if (!novosTipos.includes(1)) {
          state.tipoOperacaoModal = [];
        }
        // Se Vendedor foi deseleccionado, limpar valores
        if (!novosTipos.includes(2)) {
          state.vendedoresModal = [];
        }
        // Se Cliente foi deseleccionado, limpar valores
        if (!novosTipos.includes(3)) {
          state.clientesModal = [];
        }
        // Se Produto foi deseleccionado, limpar valores
        if (!novosTipos.includes(4)) {
          state.produtosModal = [];
        }
      },
      { deep: true },
    );

    const handleSalvar = () => {
      emit('salvar', {
        dadosCadastro: state.dadosCadastro,
        dadosRelatorioCampos: state.dadosRelatorioCampos,
        tipoOperacaoModal: state.tipoOperacaoModal,
        vendedoresModal: state.vendedoresModal,
        clientesModal: state.clientesModal,
        produtosModal: state.produtosModal,
      });
    };

    return {
      modalVisivel,
      ...toRefs(state),
      handleSalvar,
    };
  },
});
